module.exports = __webpack_public_path__ + "static/img/gggggg_13.055f7ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/gggggg_13.png
// module id = FKfp
// module chunks = 1